<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>
            Mark Handback Reason as
            @if (handbackReason.status) {
                Active
            } @else {
                Inactive
            }
        </cll-dialog-title>
        <cll-dialog-subtitle>{{ handbackReason.name }}</cll-dialog-subtitle>

    </cll-dialog-header>
    <div class="dialog-container">
        <div class="dialog-detail">
            <cll-panel-tonal colour="info">
                <cll-icon cllPanelIcon>info</cll-icon>
                <div class="panel-text-group">
                    @if (!handbackReason.status) {
                        <span class="panel-text-header">Mark as inactive</span>
                        <span class="panel-text-sub-header">This handback reason will no longer be available for selection within packages.</span>
                    } @else {
                        <span class="panel-text-header">Mark as active</span>
                        <span class="panel-text-sub-header">This handback reason will now be available for selection within packages.</span>
                    }
                </div>
            </cll-panel-tonal>
            <span>Are you sure you want to proceed?</span>
        </div>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (updateHandbackReasonRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                [disabled]="this.updateHandbackReasonRequest.loading()"
                (click)="update()">
            Confirm
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
